import { render } from "./Specifications.vue?vue&type=template&id=4de0f859&scoped=true&ts=true"
import script from "./Specifications.vue?vue&type=script&lang=ts"
export * from "./Specifications.vue?vue&type=script&lang=ts"

import "./Specifications.vue?vue&type=style&index=0&id=4de0f859&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de0f859"]])

export default __exports__